<h2 class="dialogTitle"> {{'Footer.TermofUse'|translate}}</h2>
<mat-dialog-content>
    <p [innerHtml]="'TermOfUse.Text' | translate"></p>
</mat-dialog-content>
<mat-dialog-actions align="center">
        <button type="button" color="accent" mat-flat-button  mat-dialog-close="false">{{'Actions.Close'|translate}}</button>
    </mat-dialog-actions>
